import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
    PRODUCT_LINK_SELECTOR
} from "../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { ProductModel } from "../../../datastore/entities/product.model";
import { IDropdownSettings } from "ng-multiselect-dropdown/multiselect.model";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";

@Component({
    selector: PRODUCT_LINK_SELECTOR,
    templateUrl: "./productlink.component.html"
})
export class ProductlinkComponent extends BaseComponent implements OnInit {

    @Output() public productLinkDelete = new EventEmitter<string>();
    @Output() public productLinkClose = new EventEmitter<string>();
    @Output() public productLinkSave = new EventEmitter<{
        product: ProductModel
    }>();

    @Input() public sphereUUID: string;
    @Input() public editedProductLink: ProductModel;
    @Input() public products: ProductModel[];

    public selectedItems: ProductModel[];
    public dropdownSettings: IDropdownSettings;

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        private photosphereManager: PhotosphereManager,
        protected location: Location,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    ngOnInit(): void {
        if(this.editedProductLink) {
            this.selectedItems = [
                this.editedProductLink
            ];
        }
        this.dropdownSettings = {
            singleSelection: true,
            idField: "uuid",
            textField: "name",
            enableCheckAll: false,
            allowSearchFilter: true
        };
    }

    public onProductLinkDelete() {
        this.productLinkDelete.emit();
    }

    public onProductLinkSave() {
        this.productLinkSave.emit({
            product: this.selectedItems[0]
        });
        this.selectedItems = [];
    }

    public onCloseClick() {
        this.productLinkClose.emit();
    }

    onItemSelect(_: unknown) {
        // empty
    }
}